import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs
} from "firebase/firestore";
import { db } from "../firebase";
import { useLocation, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import MenuNav from "../components/Menunav";
import MobileMenu from "../components/MobileMenu";
import BrandCard from "../components/BrandCard";

export default function ListeMarques() {
  const [marques, setMarques] = useState([]);
  const location = useLocation();

  useEffect(() => {
    const fetchMarques = async () => {
      const snap = await getDocs(collection(db, "marques"));
      const list = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setMarques(list);
    };
    fetchMarques();
  }, []);

  const keywords = `marques voiture, ${marques
    .map((m) => m.nom)
    .slice(0, 20)
    .join(", ")}, import voiture Togo, vente véhicule Afrique`;

  return (
    <>
      <MenuNav />
      <MobileMenu />

      <div className="container py-5">
        <Helmet>
          <title>Marques de Voitures Disponibles à l’Import | TheBridgeOfWorld.com</title>
          <meta
            name="description"
            content="Découvrez toutes les marques de voitures disponibles sur The Bridge of World : Toyota, Ford, Hyundai, Nissan, Kia et bien d'autres. Importation et vente de véhicules fiables au Togo."
          />
          <meta name="keywords" content={keywords} />
          <meta name="author" content="The Bridge of World" />
          <meta property="og:title" content="Marques de Voitures Disponibles | TheBridgeOfWorld.com" />
          <meta
            property="og:description"
            content="Parcourez notre sélection de marques automobiles importées. Qualité, fiabilité et large choix pour répondre à tous vos besoins en véhicules."
          />
          <meta property="og:url" content="https://thebridgeofworld.com/marques" />
          <meta property="og:type" content="website" />
        </Helmet>

        <h2 className="text-center mb-4">Toutes les Marques</h2>
        <div className="row g-4">
          {marques.map((m) => (
            <div key={m.id} className="col-6 col-md-3">
              <Link to={`/Vehiclelisting/${m.nom}`} className="text-decoration-none">
                <BrandCard nom={m.nom} />
              </Link>

            </div>
          ))}
        </div>
      </div>
    </>
  );
}
